import { Root, route } from '../utils';

const invitationsPath = `${Root}invitations`;

export default {
  invitations: {
    new: route(`${invitationsPath}/new`),
  },
};
